<template>
  <div class="right">
    <div class="xiaoxi">
      <h1><span>我的消息</span></h1>
      <img
        src="@/assets/images/empty.png"
        style="display: block; margin: 0 auto"
        v-if="messageList.length == 0"
      />
      <ul>
        <li v-for="(item, index) in messageList" :key="index">
          <i></i><a @click="showDetail(item)">{{ item.body }}</a
          ><span>{{ item.time.split(" ")[0] }}</span>
        </li>
      </ul>
    </div>
    <div class="fenye" v-if="total > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="8"
        :current-page.sync="pageNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 8,
      messageList: [],
    };
  },
  activated() {
    this.getMessageList();
  },
  methods: {
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getMessageList();
    },
    async getMessageList() {
      let _this = this;
      let param = {
        pageNum: _this.pageNum,
        pageSize: _this.pageSize,
      };
      let res = await _this.$api.message.getPageListForUser(param);
      if (res.code == _this.$commons.RespCode.success) {
        _this.messageList = res.rows;
        _this.total = Number(res.total);
      } else {
        _this.$layerMsg.error(res.msg);
      }
    },
    showDetail(item) {
      console.log("item的值是：" + JSON.stringify(item));
      let _this = this;
      if (item.type == 2) {
        _this.$router.push({ name: "examCover", query: { id: item.jumpUrl } });
        return;
      }
      if (item.type == 4) {
        _this.$router.push({ name: "articleExamCover", query: { id: item.jumpUrl } });
        return;
      }
      if (item.type == 1) {
        window.open(item.jumpUrl, "_blank");
        return;
      }
      if (item.type == 3) {
        let param = {
          enrollId: item.jumpUrl,
        };

        let newData = new Date();
        // 数据库查询出的数据 == 2020-11-28 10:10:00
        let deadlineString = item.list[0].overdueTime;
        // 数据转换 把字符串格式 转换成 日期 格式 "2023/11/28 10:10:00"
        let deadlineDate = new Date(deadlineString);
        if (newData > deadlineDate) {
          _this.$layer.alert("考试确认日期已过，如有疑问请联系工作人员");
          return;
        }
        _this.$layer.confirm(
          item.list[0].content,
          {
            btn: ["参加", "放弃"],
          },
          function (index) {
            param.joinExam = 1;
            _this.$api.sign
              .joinExam(param)
              .then((res) => {
                if (res.code == _this.$commons.RespCode.success) {
                  _this.$layer.alert("操作成功!");
                } else {
                  _this.$layer.alert(res.msg);
                  // _this.$layer.alert("您已确认参加本次考试，如需修改请联系工作人员!");
                }
              })
              .catch(() => {});
            _this.$layer.close(index);
          },
          function (index) {
            param.joinExam = 0;
            _this.$api.sign
              .joinExam(param)
              .then((res) => {
                if (res.code == _this.$commons.RespCode.success) {
                  _this.$layer.alert("操作成功!");
                } else {
                  _this.$layer.alert(res.msg);
                  // _this.$layer.alert("您已放弃参加本次考试，如需修改请联系工作人员!");
                }
              })
              .catch(() => {});
            _this.$layer.close(index);
          }
        );
        return;
      }
      _this.$layer.alert(item.body, {
        skin: "layui-layer-lan",
        closeBtn: 0,
        anim: 5, //动画类型
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/view/mine/mineMsg.vue